const CANDIDATE = {
  name: "38歳 男性 東京都",
  matchLevel: 4,
  company: "株式会社グローバルテック",
  currentPosition: "VP of Engineering",
  source: "DIRECTRECRUIT",
};

const SCOUT_MAIL = {
  subject: "【テクノフューチャー】CTO候補として技術と組織をリードしませんか",
  content: `田中様

はじめまして。株式会社テクノフューチャーの採用担当です。

田中様のVP of Engineeringとしてのご経験、
特にエンジニア組織50名規模のマネジメントと
マイクロサービスアーキテクチャへの移行を
リードされたご実績を拝見し、ぜひ弊社の
CTO候補ポジションについてお話しさせて
いただきたくご連絡いたしました。

弊社はデータ統合SaaS「DataFlow」を開発しており、
シリーズBの資金調達を完了、ARR3億円を突破しています。`,
  templateName: "技術志向エンジニア向けテンプレート",
  createdByName: "採用担当",
  createdAt: "2024-03-22",
};

const DECISIONS = [
  { label: "未確認", active: false, bg: "#6B7280" },
  { label: "送信対象", active: true, bg: "#22C55E" },
  { label: "保留", active: false, bg: "#EAB308" },
  { label: "送信しない", active: false, bg: "#4B5563" },
  { label: "送信済み", active: false, bg: "#3B82F6" },
] as const;

export function Step3MailSection() {
  return (
    <section className="border-y border-ink-100 bg-ink-50/60">
      <div className="mx-auto grid max-w-[1200px] grid-cols-1 items-center gap-12 px-6 py-24 lg:grid-cols-[minmax(0,420px)_minmax(0,1fr)]">
        <div className="self-center">
          <span className="inline-flex items-center gap-1 rounded-md bg-brand-50 px-2.5 py-1 text-[11px] font-bold tracking-wider text-brand-700">
            STEP 3 · スカウト文面作成
          </span>
          <h3 className="mt-5 text-[34px] font-bold leading-[1.2] tracking-tight md:text-[40px]">
            <span className="whitespace-nowrap">候補者ごとに、</span>
            <br />
            <span className="whitespace-nowrap">マッチした文面を作成</span>
          </h3>
          <p className="mt-5 text-[14px] leading-relaxed text-ink-600">
            AIが候補者のペルソナ・媒体ごとのトーン・自社の募集要項に応じて、興味を持ってもらえる文面を自動作成。
          </p>
          <ul className="mt-6 space-y-3 text-[14px]">
            <li className="flex items-center gap-2.5">
              <span className="grid h-5 w-5 place-items-center rounded-full bg-brand-600 text-white">
                <span className="mi text-[14px]">check</span>
              </span>
              候補者ごとのペルソナに合わせた訴求を作成
            </li>
            <li className="flex items-center gap-2.5">
              <span className="grid h-5 w-5 place-items-center rounded-full bg-brand-600 text-white">
                <span className="mi text-[14px]">check</span>
              </span>
              媒体ごとの温度感に合わせてトーンを調整
            </li>
            <li className="flex items-center gap-2.5">
              <span className="grid h-5 w-5 place-items-center rounded-full bg-brand-600 text-white">
                <span className="mi text-[14px]">check</span>
              </span>
              指示を追加して再生成も可能
            </li>
          </ul>
        </div>

        <div className="rounded-2xl border border-ink-200 bg-white p-5 shadow-card">
          <div className="flex h-full flex-col">
            {/* ヘッダー: 候補者情報 */}
            <div className="border-b border-ink-100 pb-3">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <h4 className="text-[18px] font-bold text-ink-900">{CANDIDATE.name}</h4>
                  <span className="rounded-full bg-emerald-100 px-2 py-px text-[12px] font-semibold text-emerald-800">
                    Level {CANDIDATE.matchLevel}
                  </span>
                </div>
                <div className="flex items-center gap-1">
                  <span className="mi text-[20px] text-ink-300">chevron_left</span>
                  <span className="min-w-[48px] text-center text-[12px] text-ink-500">1 / 15</span>
                  <span className="mi text-[20px] text-ink-400">chevron_right</span>
                </div>
              </div>
              <p className="mt-0.5 text-[13px] text-ink-500">
                {CANDIDATE.company} - {CANDIDATE.currentPosition}
              </p>
              <div className="mt-2 flex items-center gap-2">
                <span className="inline-flex items-center gap-1.5 rounded-md bg-blue-50 px-3 py-1.5 text-[13px] font-medium text-blue-700">
                  <span className="mi text-[16px]">open_in_new</span>
                  {CANDIDATE.source}で開く
                </span>
                <span className="inline-flex items-center gap-1.5 rounded-md bg-indigo-50 px-3 py-1.5 text-[13px] font-medium text-indigo-700">
                  <span className="mi text-[16px]">person</span>
                  候補者詳細をみる
                </span>
              </div>
            </div>

            {/* メールコンテンツ */}
            <div className="mt-3 flex-1">
              {/* 件名 */}
              <div className="mb-3">
                <div className="mb-1 flex items-center justify-between">
                  <span className="text-[12px] font-medium text-ink-700">件名</span>
                  <span className="inline-flex items-center gap-1.5 rounded-md border border-ink-200 bg-white px-3 py-1 text-[12px] font-medium text-ink-700">
                    <span className="mi text-[14px]">content_copy</span>
                    件名をコピー
                  </span>
                </div>
                <div className="rounded-md border border-ink-200 bg-ink-50 px-3 py-2 text-[13px] text-ink-800">
                  {SCOUT_MAIL.subject}
                </div>
              </div>

              {/* 本文 */}
              <div>
                <div className="mb-1 flex items-center justify-between">
                  <span className="text-[12px] font-medium text-ink-700">本文</span>
                  <span className="inline-flex items-center gap-1.5 rounded-md border-2 border-brand-600 bg-brand-600 px-3 py-1 text-[12px] font-medium text-white">
                    <span className="mi text-[14px]">content_copy</span>
                    コピーしました！
                  </span>
                </div>
                <div className="max-h-[260px] overflow-hidden whitespace-pre-wrap rounded-md border border-ink-200 bg-ink-50 px-3 py-2 text-[13px] leading-[1.6] text-ink-800">
                  {SCOUT_MAIL.content}
                </div>
              </div>

              {/* メタ情報 */}
              <div className="mt-2 text-[12px] text-ink-400">
                テンプレート: {SCOUT_MAIL.templateName} | {SCOUT_MAIL.createdByName} -{" "}
                {SCOUT_MAIL.createdAt}
              </div>
            </div>

            {/* フッター */}
            <div className="mt-3 border-t border-ink-100 pt-3">
              <div className="mb-2">
                <span className="mb-1 block text-[12px] text-ink-500">スカウトステータス</span>
                <div className="flex gap-2">
                  {DECISIONS.map((d) => (
                    <span
                      key={d.label}
                      className="flex-1 rounded-md border px-1 py-1.5 text-center text-[11px] font-medium"
                      style={{
                        borderColor: d.active ? d.bg : "#D1D5DB",
                        backgroundColor: d.active ? d.bg : "transparent",
                        color: d.active ? "#FFFFFF" : "#6B7280",
                      }}
                    >
                      {d.label}
                    </span>
                  ))}
                </div>
              </div>
              <div className="flex gap-2">
                <span className="flex flex-1 items-center justify-center gap-1 rounded-md border border-ink-200 px-3 py-2 text-[13px] text-ink-400 opacity-50">
                  <span className="mi text-[16px]">chevron_left</span>
                  前の候補者
                </span>
                <span className="flex flex-1 items-center justify-center gap-1 rounded-md border border-ink-200 px-3 py-2 text-[13px] text-ink-500">
                  次の候補者
                  <span className="mi text-[16px]">chevron_right</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
